import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api/client';

/** 연도별 추이 (백엔드 {@code /api/v1/safe/trends}) — 옛 안전보건관리시스템(V592) + 우리 기록을 달마다 센다. */

export type TrendCategoryKey = 'TBM' | 'HEALTH' | 'EDUCATION' | 'INSPECTION' | 'RISK' | 'WORK' | 'ACTION' | 'ACTION_DONE' | 'VOICE';

export type TrendSeries = {
  category: TrendCategoryKey;
  /** months 와 같은 길이 — 옛 사이트 기록. */
  legacy: number[];
  /** months 와 같은 길이 — 우리 기록. */
  current: number[];
};

export type TrendSite = {
  /** 우리 현장에 못 붙은 옛 현장이면 없다(옛 이름만). */
  siteId?: string | null;
  siteName: string;
  total: Partial<Record<TrendCategoryKey, number>>;
  recent: Partial<Record<TrendCategoryKey, number>>;
  /** 시정조치 완료를 뺀 합. */
  totalAll: number;
  recentAll: number;
  legacyCount: number;
  currentCount: number;
  firstMonth?: string | null;
  lastMonth?: string | null;
};

export type SafeTrends = {
  from: string;
  to: string;
  /** 「2022-01」 꼴. */
  months: string[];
  categories: Array<{ key: TrendCategoryKey; label: string }>;
  series: TrendSeries[];
  /** 옛 기록의 마지막 달 · 우리 기록의 첫 달. 없으면 빠진다. */
  legacyLast?: string | null;
  currentFirst?: string | null;
  /** 현장 표 「최근 12개월」 의 첫 달. */
  recentFrom?: string | null;
  sites?: TrendSite[];
};

export function useSafeTrends(params: { siteId?: string; from?: string; to?: string } = {}) {
  const query = new URLSearchParams();
  if (params.siteId) query.set('siteId', params.siteId);
  if (params.from) query.set('from', params.from);
  if (params.to) query.set('to', params.to);
  const qs = query.toString();
  return useQuery({
    queryKey: ['safe-trends', params.siteId ?? null, params.from ?? null, params.to ?? null],
    queryFn: () => apiFetch<SafeTrends>(`/v1/safe/trends${qs ? `?${qs}` : ''}`),
    // 달 단위 집계라 자주 바뀌지 않는다.
    staleTime: 10 * 60 * 1000,
  });
}
